export default __webpack_public_path__ + "static/media/John_Lovick.dd88d12a.jpg";